/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CurrentUserDetailOrganizationSettings
 */
export interface CurrentUserDetailOrganizationSettings {
    /**
     * 
     */
    billing_enabled: boolean;
}

/**
 * Check if a given object implements the CurrentUserDetailOrganizationSettings interface.
 */
export function instanceOfCurrentUserDetailOrganizationSettings(value: object): value is CurrentUserDetailOrganizationSettings {
    if (!('billing_enabled' in value) || value['billing_enabled'] === undefined) return false;
    return true;
}

export function CurrentUserDetailOrganizationSettingsFromJSON(json: any): CurrentUserDetailOrganizationSettings {
    return CurrentUserDetailOrganizationSettingsFromJSONTyped(json, false);
}

export function CurrentUserDetailOrganizationSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrentUserDetailOrganizationSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'billing_enabled': json['billing_enabled'],
    };
}

export function CurrentUserDetailOrganizationSettingsToJSON(json: any): CurrentUserDetailOrganizationSettings {
    return CurrentUserDetailOrganizationSettingsToJSONTyped(json, false);
}

export function CurrentUserDetailOrganizationSettingsToJSONTyped(value?: CurrentUserDetailOrganizationSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billing_enabled': value['billing_enabled'],
    };
}

